<ion-header><modal-header title="Edit Ideas" [editForm]="this"></modal-header></ion-header>

<ion-content [formGroup]="form" *ngIf="form">

  <ion-card class="ion-padding">
    <bones-form-items [form]="form" [items]="bonesForm.items"></bones-form-items>
  </ion-card>

</ion-content>

<ion-footer>
  <bones-edit-button-bar [editor]="this"></bones-edit-button-bar>
</ion-footer>
